import useWindowSize from '../../../shared/hooks/use-window-size';
import { IBanner } from '../../../shared/types/Personalization';
import { Nullable } from '../../../shared/types/Typescript-utils';

const useBanner = (banner?: IBanner): Nullable<{ url: string; height: number }> => {
  const windowSize = useWindowSize();

  if (!banner) {
    return null;
  }

  const { width, height, url } = banner;
  const aspect = width / height;
  const adjustedHeight = windowSize.width / aspect;

  return { url, height: adjustedHeight };
};

export default useBanner;
